import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { EMPTY, Observable, of } from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { FeatureAvailabilityService } from "@core-services/feature-availability.service";
import { Feature } from "@models/feature-list";

@UntilDestroy()
@Directive({
	selector: "[featureVisibility]",
	standalone: false
})
export class FeatureVisibilityDirective implements OnInit {
	@Input("featureVisibility") public feature: Feature = null;

	private isFeatureEnabled$: Observable<boolean> = EMPTY;

	public constructor(
		private templateRef: TemplateRef<Element>,
		private viewContainer: ViewContainerRef,
		private featureService: FeatureAvailabilityService
	) {}

	public ngOnInit(): void {
		if (!this.feature) {
			this.viewContainer.clear();
			return;
		}

		this.isFeatureEnabled$ = this.featureService?.getAvailability(this.feature) || of(false);
		this.isFeatureEnabled$.pipe(untilDestroyed(this)).subscribe((enabled: boolean) => {
			if (enabled) {
				this.viewContainer.createEmbeddedView(this.templateRef);
				return;
			}

			this.viewContainer.clear();
		});
	}
}
